import React, { useState } from 'react';
import ShipmentDataForm from './ShipmentDataForm';
import CurrencySelector from './CurrencySelector';

function Header({ categoryCounts, user, onLogout, onLoginClick, isAuthenticated, selectedCurrency, setSelectedCurrency,
                    currencyLoading, currencyError, refreshRates, formatPrice }) {
  const hdeoCount = categoryCounts?.hdmo || 0;
  const pcmoCount = categoryCounts?.pcmo || 0;
  const specialtyCount = categoryCounts?.other || 0;

  // Состояние для модального окна
  const [isShipmentModalOpen, setIsShipmentModalOpen] = useState(false);

  const handleShipmentSave = (data) => {
    console.log('Shipment data saved:', data);
    // Здесь можно добавить уведомление пользователю
  };

  return (
    <>
    <div className="hd">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px'
      }}>
        <div style={{
          display: 'inline-block',
          //padding: '2px 8px',
          background: 'rgba(255,255,255,.1)',
          borderRadius: '4px',
          fontSize: '8px',
          fontWeight: '700',
          letterSpacing: '1.5px',
          color: 'rgba(255,255,255,.7)',
          textTransform: 'uppercase'
        }}>
        {/* NOKIONE */}
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>

          {isAuthenticated ? (
            <>
              <span style={{
                fontSize: '11px',
                color: 'rgba(255,255,255,.7)'
              }}>
                {user.username}
              </span>
              <button
                onClick={onLogout}
                style={{
                  padding: '4px 12px',
                  background: 'rgba(255,255,255,.15)',
                  border: '1px solid rgba(255,255,255,.2)',
                  borderRadius: '4px',
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,.25)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,.15)';
                }}
              >
                Logout
              </button>

              {/* Кнопка для формы с Shipment Data */}
              <button
                onClick={() => setIsShipmentModalOpen(true)}
                style={{
                  padding: '4px 12px',
                  background: 'rgba(255,255,255,.15)',
                  border: '1px solid rgba(255,255,255,.2)',
                  borderRadius: '4px',
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,.25)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,.15)';
                }}
              >
                🚢 Shipment Data
              </button>
            </>
          ) : (
            <button
              onClick={onLoginClick}
              style={{
                padding: '4px 12px',
                background: 'rgba(255,255,255,.15)',
                border: '1px solid rgba(255,255,255,.2)',
                borderRadius: '4px',
                color: '#fff',
                fontSize: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,.25)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,.15)';
              }}
            >
              Login
            </button>
          )}
          {/* Выбор валюты */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <span style={{
            fontSize: '10px',
            color: 'rgba(255,255,255,.6)'
          }}>
            💱
          </span>
          <CurrencySelector
            selectedCurrency={selectedCurrency}
            onCurrencyChange={setSelectedCurrency}
            loading={currencyLoading}
          />
          {currencyError && (
            <button
              onClick={refreshRates}
              style={{
                background: 'none',
                border: 'none',
                color: '#ff6b6b',
                fontSize: '10px',
                cursor: 'pointer',
                padding: '2px 4px'
              }}
              title="Error loading currency rates. Click to update."
            >
              ⚠️
            </button>
          )}
        </div>
        </div>
      </div>
      <h1>Additive Package Portfolio</h1>
      <p>{hdeoCount} HDEO + {pcmoCount} PCMO + {specialtyCount} Specialty packages</p>
    </div>
    <ShipmentDataForm
        isOpen={isShipmentModalOpen}
        onClose={() => setIsShipmentModalOpen(false)}
        onSave={handleShipmentSave}
      />
    </>
  );
}

export default Header;
